import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Typography } from '@mui/material';
import { SanitizedMarkdown } from '../../components/sanitized-markdown';
import { DelayedLoadIndicator } from '../../components/delayed-load-indicator';
import { useExtensionChangelog } from './use-extension-details';
export const ExtensionDetailChanges = props => {
    const { data: changelogContent, isLoading: changelogLoading } = useExtensionChangelog(props.extension);
    const changelog = props.extension.files.changelog ? changelogContent : '';
    if (typeof changelog === 'undefined') {
        return _jsx(DelayedLoadIndicator, { loading: changelogLoading });
    }
    if (changelog.length === 0) {
        return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: {
                        mb: 2,
                        display: 'flex',
                        justifyContent: 'space-between',
                        ['@media(max-width: 360px)']: {
                            flexDirection: 'column',
                            '& > div:first-of-type': {
                                marginBottom: '1rem'
                            },
                            '& button': {
                                maxWidth: '12rem'
                            }
                        }
                    }, children: _jsx(Typography, { variant: 'h5', children: "Changelog" }) }), _jsx(Divider, {}), _jsx(Box, { mt: 3, children: _jsx(Typography, { children: "No changelog available" }) })] }));
    }
    return (_jsx(Box, { sx: {
            display: 'flex',
            flexDirection: {
                xs: 'column-reverse',
                sm: 'column-reverse',
                md: 'column-reverse',
                lg: 'column-reverse',
                xl: 'row'
            }
        }, children: _jsx(Box, { flex: 5, overflow: 'auto', children: _jsx(SanitizedMarkdown, { content: changelog }) }) }));
};
//# sourceMappingURL=extension-detail-changes.js.map